var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgenda1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.66666C3.61929 1.66666 2.5 2.78596 2.5 4.16666V15.8333C2.5 17.2141 3.61929 18.3333 5 18.3333H16.6667C17.1269 18.3333 17.5 17.9602 17.5 17.5C17.5 17.0397 17.1269 16.6667 16.6667 16.6667H5C4.53977 16.6667 4.16667 16.2936 4.16667 15.8333C4.16667 15.3731 4.53977 15 5 15H16.6667C17.1269 15 17.5 14.6269 17.5 14.1667V4.16666C17.5 2.78596 16.3807 1.66666 15 1.66666H5Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda1);
export default __webpack_public_path__ + "static/media/agenda1.7b9e081d1ba41509c67b6e6f17b4ff7c.svg";
export { ForwardRef as ReactComponent };